<template>
  <div>
    <div class="online_complaints" >
      <ul style="background-color:#fff;padding:0 0.2rem">
        <li>
          <span class="fl complaints_fixed complaints_tel">联系电话</span>
          <span class="fl">
           <input v-model="userTel" placeholder="请输入手机号" type="number" maxlength="11">
         </span>
        </li>
        <li @click="selectResponsibleParty">
          <span class="fl complaints_fixed complaints_reason">投诉对象</span>
          <span style='color:#9B9B9B' v-if="responsible.responsibleParty==null || responsible.responsibleParty=='' || responsible.responsibleParty==undefined">请选择</span>
          <span class="fl select-item">{{responsible.responsibleParty}}</span><span class="fr icon_arrow_down"></span>
        </li>
        <li @click="selectReason">
          <span class="fl complaints_fixed complaints_reason">投诉理由</span>
          <span style='color:#9B9B9B' v-if="responsible.responsibleParty==null || responsible.responsibleParty=='' || responsible.responsibleParty==undefined">请选择</span>
          <span class="fl select-item">{{reason.reasonDesc}}</span><span class="fr icon_arrow_down"></span>
        </li>
      </ul>
      <div class="complaints_des_box">
        <h3 class="complaints_des">详细描述</h3>
        <textarea name="" id="complaints_con" maxlength="200"  @input='descInput' v-model="content" placeholder="请输入内容">
        </textarea>
        <span>{{remnant}}/200</span>
      </div>
      <!--上传图片-->
      <div class="addPicBox">
        <div class="addimg_tips">上传凭证处理更快（不超过3张）</div>
        <div class="addPic">
          <ul class="fl">
            <li class="fl upLoadPic" v-for="(item,index) in goodsImages" >
              <div v-bind:style="{backgroundImage: 'url('+item+')'}"></div>
              <span @click="deletepic(index)"></span>
            </li>
          </ul>
          <div class="addPicBtn fl" v-show="isAddShow">
            <form id='uploadForm' method="post" enctype="multipart/form-data"><input type="file" id="uploadImg" accept="image/*" v-on:change="getImage($event)"/></form>
          </div>
        </div>
      </div>
      <div class="goodsList">
        <div class="shopName arrow-right ellipse">{{shopName}}</div>
        <ul>
          <li v-for="item in goodsList" style="display: flex;justify-content: space-between">
            <div class="flexrow" style="width: 60%">
              <img class="shopPic" :src='item.picAddr' />
              <div class="goodsName flexcol" style="width:60%; height:100%;justify-content: space-between;">
                <div class="ellipse" style="width: 60%;color:#333;font-weight: bold">{{item.title}}</div>
                <div style="color: #9B9B9B">x{{item.number}}</div>
              </div>
            </div>
            <div class="goodsPri">￥ {{item.salePrice}}</div>
          </li>
        </ul>
      </div>
      <div class="btn submit_btn" @click="submit" >提交</div>
      <!--选择责任方、理由弹框-->
      <div v-show="flag1" class="complaints_reason_select" @click="hiddenList(1)">
        <ul >
          <li class='reason_list' ref="menuItem" v-for="(item,index) in responsiblePartyList" @click='handleClick1(item,index)' v-bind:class='{on:item.isDefault==1}'>
            <span>{{item.responsibleParty}}</span><span class="icon_selected"></span>
          </li>
        </ul>
      </div>
      <div v-show="flag" class="complaints_reason_select" @click="hiddenList(2)">
        <ul >
          <li class='reason_list' ref="menuItem" v-for="(item,index) in reasonList" @click='handleClick(item,index)' v-bind:class='{on:item.isDefault==1}'>
            <span>{{item.reasonDesc}}</span><span class="icon_selected"></span>
          </li>
        </ul>
      </div>
      <div class="telComplaint">
        <!--<a @click="dialingClick(tel)"></a>-->
        <a :href="'tel:'+ tel"></a>
      </div>
    </div>
  </div>
</template>

<script>
    import {actions} from '../store/actions'
    import PreviewPicture from "../components/PreviewPicture"
    // import { Indicator,Toast,MessageBox } from 'mint-ui'

  	export default {
  	  data () {
  	    return {
          orderId: window.localStorage.getItem('orderCode'),
          flag1: false, //控制责任方列表弹框
          flag: false, //控制投诉理由列表弹框
          isAddShow: true, //控制上传图片按钮
          userTel: '',
          shopName: '',
          content: '',
          remnant: 200,
          responsiblePartyList: [],//责任方列表
          reasonList: [], //投诉理由列表
          responsible: '',
          reason: '',
          goodsImages: [],
          tel: '',
          isCanApplyRefund: 0,
          isRefund: false,
          goodsList: [],
  	    }
  	  },
      computed: {
        wxUid () {
          return this.$store.state.wxUid
        }
      },
      // created () {
      //   document.title = "投诉";
      // },
      mounted () {
        var _this = this;
        _this.getcomplaintInfo();
      },
  	  methods: {
        getcomplaintInfo: function (){
          var _this = this
          var params = {
            orderId: _this.orderId
          }
          _this.$indicator.open();//loading
          actions.getApplyComplaints(_this, params, function (data){
            _this.$indicator.close();
            _this.userTel = data.userTel
            _this.shopName = data.shopName
            _this.goodsList = data.goodsList
            _this.isCanApplyRefund = data.isCanApplyRefund
            var params = {
              commercial_id: data.commercialId,
              school_id: data.schoolId
            };
            actions.getCommercialTel(_this, params, function (data1) {
              _this.tel = data1
            })
            for (var i = 0; i < data.applyResponsibleReasonList.length; i++) {
              _this.responsiblePartyList[i] = data.applyResponsibleReasonList[i]
              // if(_this.responsiblePartyList[i].isDefault == 1){
              //   _this.responsible = _this.responsiblePartyList[i]
              //   _this.reasonList = _this.responsiblePartyList[i].reasonList
              // }
            }
            // for (var i = 0; i < _this.reasonList.length; i++) {
            //   if (_this.reasonList[i].isDefault == 1) {
            //     _this.reason = _this.reasonList[i]
            //   }
            // }
            console.log(_this.responsiblePartyList)
          },function (data){
            _this.$indicator.close();
            _this.$messagebox.alert(data.body.message,'')
          })
        },
        selectResponsibleParty: function () {
          this.flag1 = !this.flag1
        },
  	    selectReason: function () {
          if (this.responsible.responsibleParty !== '' && this.responsible.responsibleParty != null && this.responsible.responsibleParty !== undefined ) {
            this.flag = !this.flag
          } else {
            this.$messagebox.alert('请选择投诉对象', '')
          }

  	    },
        //选择投诉对象
        handleClick1: function (item, index) {
          var _this = this
          _this.responsible = item
          _this.flag1 = false
          for (var i = 0; i < _this.responsiblePartyList.length; i++) {
            if(i == index) {
              _this.responsiblePartyList[i].isDefault = 1
            } else {
              _this.responsiblePartyList[i].isDefault = 0
            }
            if (_this.responsiblePartyList[i].responsibleParty == item.responsibleParty) {
              _this.reasonList = _this.responsiblePartyList[i].reasonList
            }
          }
          for (var i = 0; i < _this.reasonList.length; i++) {
            if (_this.reasonList[i].isDefault === 1) {
              _this.reason = _this.reasonList[i]
            }
          }
        },
        // 选择投诉理由
        handleClick: function (item, index) {
          this.reason = item
          this.flag = false
          for (var i = 0; i < this.reasonList.length; i++ ) {
            if (i == index) {
              this.reasonList[i].isDefault = 1
            }else{
              this.reasonList[i].isDefault = 0
            }
          }
        },
        //点击空白处隐藏理由列表弹框
        hiddenList: function (index) {
          if (index == 1) {
            this.flag1 = false
          }
          if(index == 2){
            this.flag = false
          }
        },
        descInput: function () {
          var _this = this
          var txtVal = _this.content.length;
          if (txtVal <= 200) {
            _this.remnant = 200 - txtVal;
          }
        },
        //上传图片
        getImage: function(e){
          var _this = this
          let host = _this.$utils.getSpliceHost('manager-center')
//          if(process.env.NODE_ENV=='local'){
//            host = 'http://manager-center.imcoming.com.cn'
//          }else if(process.env.NODE_ENV=='development'){
//            host = 'http://manager-center.imcoming.com.cn'
//          }else if(process.env.NODE_ENV=='test'){
//            host = 'http://manager-center.imcoming.com'
//          }else{
//            host = 'https://manager-center.anlaiye.com'
//          }
          var url = host+'/api/fileupload/upBase64'
          let file = e.target.files[0];
          if (!/image\/\w+/.test(file.type)) {
            _this.$messagebox.alert("请选择图片",'');
            return false;
          }
          _this.$indicator.open();//loading
         // 通过canvas压缩图片
          var reader = new FileReader();
          reader.readAsDataURL(file);
          var img = new Image;
          reader.onload = function (e) {
            var width = 320, //图像大小
                quality = 0.8, //图像质量
                canvas = document.createElement("canvas"),
                drawer = canvas.getContext("2d");
            img.src = this.result;
            img.onload = function () {
              canvas.width = width;
              canvas.height = width * (img.height / img.width);
              drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
              let imgsrc = canvas.toDataURL ("image/png", quality);
              _this.$http.post(url, {src: imgsrc},{emulateJSON: true}).then(function (response) {
                _this.goodsImages.push(response.body.data.path)
                if(_this.goodsImages.length>=3){
                  _this.isAddShow = !_this.isAddShow
                }
                // _this.loading = false;
                _this.$indicator.close();
                // 响应成功回调
              }, function (response) {
                // 响应错误回调
                _this.$indicator.close();
              })
            }
          }
        },
        // 删除图片
        deletepic: function (index){
          var _this = this
          _this.goodsImages.splice(index, 1)
          if (!_this.isAddShow) {
            _this.isAddShow = !_this.isAddShow
          }
        },
        //提交投诉
        submit: function () {
          var _this = this
          if(_this.userTel !== '' && _this.responsible.responsibleParty !== undefined && _this.reason.reasonDesc !== undefined && _this.content !== '') {
            _this.$messagebox.confirm('是否提交投诉?', '').then(function (action) {
              var params = {
                orderId: _this.orderId,
                userTel: _this.userTel,
                complaintContent: _this.content,
                complaintImages: _this.goodsImages,
                responsibleCode: _this.responsible.responsibleCode,
                reasonCode: _this.reason.reasonCode,
                goodsList: _this.goodsList,
                isApplyRefund: 0
              }
              actions.postSaveComplaint(_this, params, function () {
                _this.$messagebox.alert('提交成功', '').then(function (action) {
                  _this.$router.go(-1);
                });
              }, function (data) {
                _this.$messagebox.alert(data.body.message, '')
              })
            })
          } else if (_this.userTel === '') {
            _this.$messagebox.alert('请输入手机号码', '')
          } else if (_this.responsible.responsibleParty === '' || _this.responsible.responsibleParty === undefined || _this.responsible.responsibleParty == null){
            _this.$messagebox.alert('请选择投诉对象', '')
          } else if (_this.reason.reasonDesc === '' || _this.reason.reasonDesc === undefined || _this.reason.reasonDesc == null) {
            _this.$messagebox.alert('请选择投诉理由', '')
          } else if (_this.content === '') {
            _this.$messagebox.alert('请填写详细描述', '')
          }
        }
      },
      components: {
        PreviewPicture
      }
  	}
</script>



// WEBPACK FOOTER //
// OnlineComplaints.vue?86e86798